import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

interface TestResultsCardProps {
  onClick: () => void;
}

export default function TestResultsCard({ onClick }: TestResultsCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getCardTitleText = () => {
    return (
      t("screening.test_results_card_title_nj") ??
      `Docket now supports certain test results recorded.`
    );
  };

  const getCardBodyText = () => {
    return t("screening.test_results_card_body_nj") ?? "Tap here to access your results.";
  };

  return (
    <>
      <div
        className="flex flex-col sm:h-[5em] md:h-[7em] disclaimer-card mobile-card cursor-pointer"
        onClick={onClick}
      >
        <div className="disclaimer-badge-bg"></div>
        <div className="disclaimer-badge text-xs ml-1 font-semibold text-white">
          {t("screening.records_status_lead")}
        </div>

        <div className="flex gap-1 ml-12 md:py-3 max-md:py-2 h-full">
          <div className="flex flex-col my-auto">
            <div
              role="paragraph"
              className="text-dark text-xs font-bold"
              data-testid="disclaimer-card-title"
            >
              {getCardTitleText()}
            </div>
            <p className="text-sm text-gray-400">{getCardBodyText()}</p>
          </div>

          <div className="my-auto md:mr-4 ml-auto max-md:mr-1">
            <img
              className="disclaimer-card-mic-img"
              src="/assets/images/Tests_Generic.png"
              alt="Lead Result Tests"
            />
          </div>
        </div>
      </div>
    </>
  );
}
